export default "__VITE_ASSET__C$mh9Yux__"